import { useCallback, useEffect, useState } from "react";
import { getPosition } from "../../services/customerTouchPoint";

const usePosition = () => {
  const [data1, setData1] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getPosition();
    let newValue = [];
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      objectValue.map((item) => {
        newValue.push({
          id: item.positionUniqueId,
          value: item.positionNameTh,
        });
      });

      setData1(newValue);
    }
  }, [setData1]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data1];
};

export default usePosition;
